import type { ReactNode } from "react";
import styles from "./MarketingSectionHeader.module.css";

interface MarketingSectionHeaderProps {
  kicker: string;
  title: ReactNode;
  caption?: ReactNode;
}

export function MarketingSectionHeader({ kicker, title, caption }: MarketingSectionHeaderProps) {
  return (
    <div className={styles.header}>
      <span className={styles.kicker}>{kicker}</span>
      <h2 className={styles.title}>{title}</h2>
      {caption && <p className={styles.caption}>{caption}</p>}
    </div>
  );
}
